// Technický stav zariadenia for operational log entries (prevádzkový denník)
// Keep in sync with server/config/technicalConditions.js
export const TECHNICAL_CONDITIONS = {
    NO_DEFECT: 'NO_DEFECT',
    MINOR_DEFECT: 'MINOR_DEFECT',
    SERIOUS_DEFECT: 'SERIOUS_DEFECT',
};

export const TECHNICAL_CONDITION_LABELS = {
    NO_DEFECT: 'Bez závad',
    MINOR_DEFECT: 'Menšia závada',
    SERIOUS_DEFECT: 'Vážna závada',
};

export const TECHNICAL_CONDITION_OPTIONS = Object.entries(TECHNICAL_CONDITION_LABELS).map(([value, label]) => ({ value, label }));
